module.exports = __webpack_public_path__ + "img/豆浆.854e5ee6.png";